import { postToApp } from '../../../../lib/rnBridge';

/** 当前 step 首屏 UI 可展示时通知 App（不必等 window.load / 次要弹窗模块） */
export function notifyOpenProgressReady(step: number) {
  postToApp({
    type: 'WEB_TO_APP_OpenProgressReady',
    payload: { step, ts: Date.now() },
  });
}
